<wr-new-data-table headerText="Prüfpunkt Gruppen"
                   [infoBanner]="catalogBanner()"
                   localStorageIdentifier="checkpoint-group-overview"
                   [loadItemsFunction]="loadCheckpointGroups"
                   [getCountFunction]="getCount"
                   [defaultSort]="{ sort: 'number', order: 'ASC' }"
                   (lineClick)="navigateToCheckpointGroup($event)"
                   (newClick)="add()"
                   [form]="form"
                   [isAdmin]="isAdmin()"
                   [deprecatedRows]="true">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-items">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="deprecated">Prüfpunkt Status</label>
          <wr-deprecated-select id="deprecated" formControlName="deprecated"></wr-deprecated-select>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-checkpointGroup
    key="number"
    display="Nummer">
    <div>
      {{checkpointGroup.number}}
    </div>
  </ng-template>
  <ng-template
    dataColumn
    let-checkpointGroup
    key="name"
    display="Gruppenname">
    <div>
      {{cleanName(checkpointGroup.name)}}
    </div>
  </ng-template>
</wr-new-data-table>
